import { defineStore } from 'pinia';

export const useSessionExpiredStore = defineStore('sessionExpired', {
    state: (): { sessionExpired: boolean } => ({
        sessionExpired: false,
    }),
    getters: {
        getSessionExpired: state => state.sessionExpired,
    },
    actions: {
        setSessionExpired(value: boolean): void {
            this.sessionExpired = value;
        },
    },
});
